import GatedCompanionSummaryModule from './GatedCompanionSummaryModule';

export default GatedCompanionSummaryModule;
